import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import Nordic1 from "../images/nordic_1.jpg"
import Nordic2 from "../images/nordic_2.jpg"
import Nordic3 from "../images/nordic_3.jpg"
import Nordic4 from "../images/nordic_4.jpg"
import Nordic5 from "../images/nordic_5.jpg"
import Nordic6 from "../images/nordic_6.jpg"
import Nordic7 from "../images/nordic_7.jpg"
import Nordic8 from "../images/nordic_8.jpg"

const NordicCustomerSupport = () => (
  <Layout>
    <SEO title="Nordic Customer Support Tool App" />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader title="Nordic Customer Support Tool" subtitle="Design" />
      <ProductSection
        override={
          <div className="w-full flex justify-center">
            <div className="flex flex-wrap items-center justify-center">
              <img
                src={Nordic1}
                className="w-full md:w-1/2 lg:w-1/4 mr-6 mb-6 rounded-lg"
              />
              <img
                src={Nordic2}
                className="w-full md:w-1/2 lg:w-1/4 mr-6 mb-6 rounded-lg"
              />
              <img
                src={Nordic3}
                className="w-full md:w-1/2 lg:w-1/4 mr-6 mb-6 rounded-lg"
              />
              <img
                src={Nordic4}
                className="w-full md:w-1/2 lg:w-1/4 mr-6 mb-6 rounded-lg"
              />
              <img
                src={Nordic5}
                className="w-full md:w-1/2 lg:w-1/4 mr-6 mb-6 rounded-lg"
              />
              <img
                src={Nordic6}
                className="w-full md:w-1/2 lg:w-1/4 mr-6 mb-6 rounded-lg"
              />
              <img
                src={Nordic7}
                className="w-full md:w-1/2 lg:w-1/4 mr-6 mb-6 rounded-lg"
              />
              <img
                src={Nordic8}
                className="w-full md:w-1/2 lg:w-1/4 mr-6  mb-6 rounded-lg"
              />
            </div>
          </div>
        }
      />
    </div>
  </Layout>
)

export default NordicCustomerSupport
